"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const recentSearchList_1 = require("../../modules/recentSearchList");
const RecentItem_1 = __importDefault(require("./RecentItem"));
const StyledRecentSearchBox_1 = require("./styled/StyledRecentSearchBox");
const RecentSearchBox = (props) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [props.list && props.list.length > 0 && ((0, jsx_runtime_1.jsx)(RecentSearchBox.Header, { setRecentList: props.setRecentList })), (0, jsx_runtime_1.jsx)(RecentSearchBox.List, { ...props }), (0, jsx_runtime_1.jsx)(RecentSearchBox.Spacer, {})] }));
};
const Header = react_1.default.memo(({ setRecentList, }) => {
    return ((0, jsx_runtime_1.jsxs)(StyledRecentSearchBox_1.RecentSearchHeaderDiv, { className: "Recent__List__Header", children: [(0, jsx_runtime_1.jsx)("span", { className: "Recent__List__Title", children: "\uCD5C\uADFC \uAC80\uC0C9\uC5B4" }), (0, jsx_runtime_1.jsx)("button", { className: "Recent__List__Clear", onClick: () => {
                    (0, recentSearchList_1.clearRecent)(setRecentList);
                }, children: "\uBAA8\uB450 \uC9C0\uC6B0\uAE30" })] }));
});
const List = react_1.default.memo(({ list, setRecentList, onRecentSearch, onAutoCompClick }) => {
    return ((0, jsx_runtime_1.jsx)(StyledRecentSearchBox_1.RecentSearchListDiv, { className: "Recent__List__Box", children: list.slice(0, 5).map((item, idx) => {
            const autoContent = item.content;
            return ((0, jsx_runtime_1.jsx)(RecentItem_1.default, { idx: idx, item: item, setRecentList: setRecentList, onRecentSearch: onRecentSearch, onAutoCompClick: onAutoCompClick }, typeof item.content === "string"
                ? item.content + item.time
                : (autoContent.main_name ? autoContent.main_name : "") +
                    autoContent.rest_id +
                    item.time));
        }) }));
});
const Spacer = react_1.default.memo(() => {
    return (0, jsx_runtime_1.jsx)(StyledRecentSearchBox_1.RecentSearchSpacer, { className: "Recent__Search__Spacer" });
});
RecentSearchBox.Header = Header;
RecentSearchBox.List = List;
RecentSearchBox.Spacer = Spacer;
exports.default = RecentSearchBox;
